import React from 'react';
import PropTypes from 'prop-types';
import Button from '@components/smartAdminUI/Button';

const AgentLookupActionButtons = ({
  agentSelected,
  currRow,
}) => {
  const handleClick = () => agentSelected(currRow);

  return (
    <div className="d-flex">
      <Button
        onClick={handleClick}
        variant="primary btn-sm"
        data-dismiss="modal"
        data-target="#agentLookupModal"
        tooltipText="Select Agent"
      >
        <i className="far fa-plus" />
      </Button>
    </div>
  );
};

AgentLookupActionButtons.propTypes = {
  agentSelected: PropTypes.func.isRequired,
  currRow: PropTypes.shape({
    UniqueID: PropTypes.number,
  }),
};

export default AgentLookupActionButtons;
